import React, { Component } from 'react';
import Select from 'react-select';
import { components, createFilter } from 'react-select';
import { FixedSizeList as List } from "react-window";

const height = 45;

class MenuList extends Component {
  render() {
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    if (children.length && children.length > 0){
      return (
        <List
          height={Math.min(maxHeight, children.length * height + height)}
          itemCount={children.length}
          itemSize={height}
          initialScrollOffset={initialOffset}
        >
          {({ index, style }) => <div style={style}>{children[index]}</div>}
        </List>
      );
    } else{
      return (
          <components.NoOptionsMessage {...this.props}/>
      );
    }
  }
}


const valuesFromIds = (opts, ids) => { return (!!ids && !!opts) ? opts.filter(o => ids.includes(o.value)) : null;}

export default class EditableSubject extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getSubjects(),
    };
  }

  getSubjects() {
    return this.props.subjects ? this.props.subjects : [];
  }

  handleChange = (value_object) => {
    const values = value_object.map((val) => val.value);
    this.setState({ value: values });
    if (this.props.update) {
      const newSubs = values ? values : [];
      this.props.update('subjects', newSubs);
    }
  }

  render() {
    return (<Select
      isMulti
      key="subject-select"
      className="Select"
      filterOption={createFilter({ignoreAccents: false})}
      name={this.props.name}
      value={valuesFromIds(this.props.subjectData, this.state.value)}
      components={{ MenuList }}
      options={this.props.subjectData}
      onChange={this.handleChange}
    />);
  }

}